export default "__VITE_ASSET__asvG5xp4__"